export default __webpack_public_path__ + "static/media/slider3.1beaa216.jpg";